<template>
  <div class="w-100">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div v-if="create_page == 2">
      <div class="request-pr-form-wrap">
        <div class="request-pr-form-title">
          ファイルをアップロード
          <div class="flex-space"></div>
          <a :href="s3BaseUrl + '/templete/import_report.xlsx'">
            <el-button type="info" size="small" style="margin: -7px">
              <font-awesome-icon :icon="['far', 'arrow-to-bottom']" style="margin-right: 5px;" />
              テンプレートファイルをダウンロード
            </el-button>
          </a>
        </div>
        <div class="request-pr-form-parts" style="flex-flow: column">
          <ul class="request-pr-form-description">
            <li>インポートするファイルには、下記の項目をヘッダー行(1行目)に設定してください</li>
            <ul class="request-pr-form-description">
              <li>必須項目: フィード投稿URL <span style="color:red">*</span></li>
              <li>任意項目: インプレッション数/リーチ数/保存数/シェア数/再生数/コスト/コメント</li>
            </ul>
          </ul>
          <div class="request-pr-divider"></div>
          <ul class="request-pr-form-description">
            <li>{{ siteName }} 上に登録がある2021年1月1日以降の投稿のみインポートできます。</li>
            <li>インフルエンサーユーザー名などの情報は自動で参照されます。</li>
            <li>いいね数/コメント数は、{{ siteName }} 上の直近数値が自動で参照されます。</li>
            <li>フォロワー数は、投稿日前後のフォロワー数が自動で参照されます。</li>
            <li>エンゲージメント数は、各エンゲージメント数値(いいね数/コメント数/保存数/シェア数)に基づき自動で算出されます。</li>
            <li>インプレッション率などのパーセンテージ指標は、各数値に基づき自動で算出されます。</li>
            <!-- <li v-show="sns_type != 'youtube'">正確なユーザー名でない場合(全角文字や@が含まれている場合など)、データをインポートできません</li>
          <li v-show="sns_type == 'youtube'">チャンネルURLは、[youtube.com/user/...] または [youtube.com/channel/....] の形式のみ対応しています</li> -->
          </ul>
          <div class="import-upload-error" v-if="upload_error">
            <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />
            {{ upload_error_message }}
          </div>
          <div class="import-subwrap">
            <el-upload
              drag
              accept=".csv,.xlsx,.xls"
              :auto-upload="false"
              :action="'test'"
              :on-change="addFile"
              :on-remove="deleteFile"
              :show-file-list="false"
              :disabled="file_uploaded"
              :class="file_uploaded ? 'uploaded' : ''"
            >
              <div v-if="!file_uploaded" v-loading="file_loading" class="import-beforeupload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">ファイルをドロップもしくは<em>選択してアップロード</em></div>
              </div>
              <div v-else class="import-uploaded">
                <div class="import-uploaded-icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
                <div class="import-uploaded-filename">{{ uploaded_info.uploaded_name }} <br />がアップロードされました</div>
                <div class="import-uploaded-close" @click="deleteFile()">
                  <font-awesome-icon :icon="['fal', 'times']" />
                </div>
              </div>
            </el-upload>
          </div>
          <span>.csv .xlsx .xls形式のファイルタイプに対応しています。</span>
        </div>
      </div>
      <div class="request-pr-form-buttonarea">
        <el-button @click="createReportPageBack()" type="primary" v-if="parent_component != 'report_detail'">戻る</el-button>
        <el-button @click="createReportPageNext()" type="primary" :disabled="!file_uploaded">次へ</el-button>
      </div>
    </div>
    <div v-if="create_page == 3">
      <div class="request-pr-form-wrap">
        <div class="request-pr-form-title">
          インポート項目を確認
          <div class="flex-space"></div>
          <div style="font-weight:400; font-size:12px">インポートする項目、インポート内容を確認し、問題なければインポートを行ってください</div>
        </div>
        <div class="request-pr-form-parts">
          <div class="request-pr-form-subtitle" style="min-width:160px">
            インポートファイル名
          </div>
          <el-input type="text" v-model="uploaded_info.uploaded_name" disabled></el-input>
        </div>
        <div class="request-pr-form-parts">
          <div class="request-pr-form-subtitle" style="min-width:160px">
            データ件数
          </div>
          <div style="margin-top:5px">
            アップロード:<span class="import-num">{{ uploaded_info.uploaded_num }}</span
            >件 / インポート可能:<span class="import-num">{{ uploaded_info.exist_num }}</span
            >件 / {{ siteName }} 未登録
            <el-tooltip>
              <div slot="content">{{ siteName }} に登録されておらず、データのインポートができない投稿の件数です。</div>
              <font-awesome-icon :icon="['fas', 'question-circle']" />
            </el-tooltip>
            :<span class="import-num">{{ uploaded_info.noexist_num }}</span
            >件
          </div>
        </div>
        <div class="divider-nomargin"></div>
        <div class="import-table-menu">
          <div class="import-table-menu-button pointer" :class="data_button == 'exist' ? 'active' : ''" @click="uploaded_info.exist_num > 0 ? (data_button = 'exist') : ''">
            インポート可能({{ uploaded_info.exist_num }})
          </div>
          <div class="import-table-menu-button pointer" :class="data_button == 'noexist' ? 'active' : ''" @click="uploaded_info.noexist_num > 0 ? (data_button = 'noexist') : ''">
            {{ siteName }} 未登録({{ uploaded_info.noexist_num }})
          </div>
          <div class="flex-space"></div>
          <div>上位50件までの投稿データを表示</div>
        </div>
        <div class="import-table-wrap" id="data-table">
          <table border="0" class="import-table">
            <thead>
              <tr>
                <th v-for="(header, header_index) in uploaded_data.header" :key="header.title" class="import-table-th" :class="header_index == sticky_index ? 'import-table-th-title' : ''">
                  <div class="import-table-th-div">
                    {{ header.title }}
                    <font-awesome-icon :icon="['fas', 'check-circle']" v-if="header.importable" style="margin-left:3px; font-size:12px; color: #27b933" />
                    <el-tooltip :disabled="header.importable" placement="top">
                      <div slot="content">有効なヘッダータイトルではないため、この列はインポートできません</div>
                      <font-awesome-icon :icon="['fas', 'exclamation-circle']" v-if="!header.importable" style="margin-left:3px; font-size:12px; color: #f56c6c" />
                    </el-tooltip>
                  </div>
                </th>
                <th class="import-table-th-flex"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, list_index) in data_button == 'exist' ? uploaded_data.exist : uploaded_data.noexist" :key="list_index" class="import-table-tr">
                <td v-for="(item, item_index) in list" :key="item_index" class="import-table-td" :class="item_index == sticky_index ? 'import-table-td-title' : ''">
                  <div class="import-table-td-div">
                    <span>{{ item.value }}</span>
                  </div>
                </td>
                <td class="import-table-td-flex"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="divider-nomargin"></div>
        <div class="request-pr-form-parts" v-if="parent_component != 'report_detail'">
          <div class="request-pr-form-subtitle">
            データ集計期間
            <span style="color:red">*</span>
            <el-tooltip>
              <div slot="content">エンゲージメントの期間データを作成します。<br />最大で2ヶ月間設定可能です。</div>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px; color: #aaa" />
            </el-tooltip>
          </div>
          <el-date-picker
            v-model="tracking_date"
            type="daterange"
            start-placeholder="開始日"
            end-placeholder="終了日"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            align="right"
            clearable
            :picker-options="pickerOptions"
            :default-value="default_date"
          ></el-date-picker>
        </div>
      </div>
      <div class="request-pr-form-buttonarea">
        <el-button @click="createReportPageBack()" type="info" :disabled="import_loading">戻る</el-button>
        <el-button @click="importFile()" type="primary" :disabled="import_loading">
          <div class="flex-row">
            インポートする
            <div class="loader--mini" v-show="import_loading"></div>
          </div>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const uploadAPI = root + "/api/report/upload";
const importAPI = root + "/api/report/import";

export default {
  name: "reportCreateUpload",
  props: ["create_page", "create_type", "report", "parent_component"],
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      file: "",
      fileList: [],
      file_loading: false,
      file_uploaded: false,
      uploaded_data: [],
      uploaded_info: [],
      upload_error: false,
      upload_error_message: "",
      data_button: "exist",
      sticky_index: -1,
      import_loading: false,
      tracking_date: [],
      default_date: new Date().setMonth(new Date().getMonth() - 1),
      selectData: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
        onPick: this.onPick,
      },
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {},
  methods: {
    onPick(time) {
      this.selectData = time.minDate.getTime();
      if (time.maxDate) this.selectData = "";
    },
    disabledDate(time) {
      if (this.selectData) {
        var start = new Date(this.selectData);
        var end = new Date(this.selectData);
        return time.getTime() < start.setMonth(start.getMonth() - 2) || time.getTime() > end.setMonth(end.getMonth() + 2) || time.getTime() > new Date();
      } else {
        var dt = new Date();
        dt.setMonth(dt.getMonth() - 5);
        dt.setDate(dt.getDate() - 1);
        return time.getTime() < dt || time.getTime() > new Date();
      }
    },
    addFile(file, fileList) {
      this.file = "";
      this.fileList = [];
      this.file = file;
      this.fileList = fileList;
      this.file_loading = true;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      formData.append("token", this.token);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.axios
        .post(uploadAPI, formData, config)
        .then((response) => {
          if (response.data.status == "OK") {
            this.uploaded_data = response.data.uploaded_data;
            this.uploaded_info = response.data.uploaded_info;
            this.sticky_index = response.data.required_index;
            if (this.uploaded_info.exist_num > 0) {
              this.data_button = "exist";
            } else {
              this.data_button = "noexist";
            }
            setTimeout(() => {
              this.upload_error = false;
              this.file_loading = false;
              this.file_uploaded = true;
            }, 1000);
          } else {
            setTimeout(() => {
              this.file_loading = false;
              this.file_uploaded = false;
              this.upload_error = true;
              this.upload_error_message = response.data.error_message;
            }, 1000);
          }
        })
        .catch(() => {
          this.file_loading = false;
        });
    },
    deleteFile() {
      this.file = "";
      this.fileList = [];
      this.uploaded_data = [];
      this.uploaded_info = [];
      this.upload_error = false;
      this.upload_error_message = "";
      this.data_button = "exist";
      setTimeout(() => {
        this.file_uploaded = false;
      }, 1);
    },
    importFile() {
      if (!this.tracking_date[1] && this.parent_component != "report_detail") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "データ集計期間が選択されていません",
        });
      } else {
        this.$confirm("インポートを実行してもよろしいですか？", "レポートのインポート", {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          type: "warning",
          confirmButtonText: "インポート",
          cancelButtonText: "キャンセル",
        }).then(() => {
          this.import_loading = true;
          var formData = new FormData();
          formData.append("file", this.file.raw);
          formData.append("token", this.token);
          formData.append("user_token", this.user_token);
          formData.append("import_type", this.parent_component == "report_detail" ? "add" : "new");
          if (this.parent_component == "report_detail") {
            formData.append("report_id", this.report.report_id);
          } else {
            formData.append("sns_type", this.report.sns_type);
            formData.append("assign", this.report.assign);
            formData.append("report_name", this.report.report_name);
            formData.append("start_at", this.tracking_date[0]);
            formData.append("end_at", this.tracking_date[1]);
          }
          var config = {
            headers: {
              "content-type": "multipart/form-data",
            },
          };
          this.axios
            .post(importAPI, formData, config)
            .then((response) => {
              this.deleteFile();
              this.import_loading = false;
              this.$emit("update:create_page", 1);
              this.$emit("closeDrawer");
              if (this.parent_component == "report_detail") this.$router.push("/report");
              this.$confirm("インポート後、レポート作成が完了するまで2~3分かかる場合があります。", response.data.exist_num + "件の投稿のインポート・レポート作成を行いました", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              }).then(() => {});
            })
            .catch(() => {
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "インポートに失敗しました",
              });
              this.$emit("update:create_page", 1);
              this.import_loading = false;
            });
        });
      }
    },
    createReportPageBack() {
      let page = this.create_page;
      this.$emit("update:create_page", (page -= 1));
    },
    createReportPageNext() {
      let page = this.create_page;
      this.$emit("update:create_page", (page += 1));
    },
    alert() {
      var message = "ファイルをアップロードしてください";
      this.$message({
        type: "error",
        offset: 7,
        showClose: true,
        message: message,
      });
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  watch: {
    create_page() {
      if (this.create_page >= 3 && this.create_type == "manual" && !this.file_uploaded) {
        let page = this.create_page;
        this.$emit("update:create_page", (page -= 1));
        this.alert();
      }
    },
  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
  },
};
</script>
